var _style, _circle, _defs, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSiderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101 34",
    style: {
      height: 50
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_00000146486503635237427420000013980877616392385706_);}\n\t.st2{clip-path:url(#SVGID_00000014614894792474823170000016510198715977867190_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#0076CE;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#0368B8;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#055CA1;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#02477D;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#004986;}\n\t.st8{fill:#004986;}\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50.1,
    cy: 17.6,
    r: 15.9
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    width: 100.9,
    height: 34
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125601443610242298030000009876570557051144851_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000125601443610242298030000009876570557051144851_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000151526862233005926990000007643524389050420140_",
    x: 0,
    width: 100.9,
    height: 34
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050639111146373515670000007292705380401731230_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151526862233005926990000007643524389050420140_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000050639111146373515670000007292705380401731230_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4.5,24.5H0.5l0,0L0,26.4h4.1L4.5,24.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8,24.5H5l0,0l-0.4,1.9h3L8,24.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M11,24.5H8.5l0,0l-0.4,1.9h2.5L11,24.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M13.6,24.5h-2.1l0,0l-0.4,1.9h2.1L13.6,24.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.2,20.1C10,21,9.7,21.6,9.3,21.9c-0.4,0.3-1.1,0.4-2.2,0.4H0.9l0.4-1.9h5.3c0.5,0,0.9,0,1-0.1       c0.2-0.1,0.4-0.5,0.5-1l0.1-0.2c0.1-0.3,0.1-0.5,0.1-0.6c0-0.3-0.2-0.5-0.6-0.5H4.4c-0.7,0-1.3-0.2-1.7-0.5       c-0.3-0.3-0.5-0.6-0.5-1.1c0-0.1,0-0.2,0-0.4l0.5-2.1c0.2-0.9,0.5-1.6,0.9-1.8c0.4-0.3,1.1-0.4,2.2-0.4H12l-0.4,1.9H6.3       c-0.5,0-0.9,0.1-1,0.1c-0.2,0.1-0.3,0.5-0.5,1l0,0.2c-0.1,0.3-0.1,0.5-0.1,0.6c0,0.2,0.1,0.4,0.4,0.5c0.1,0,0.3,0,0.7,0h3.1       c1.2,0,1.8,0.6,1.8,1.7c0,0.2,0,0.4-0.1,0.6L10.2,20.1L10.2,20.1z M20.1,22.3h-2.3l0.4-1.9c0.1-0.3,0.1-0.5,0.1-0.6       c0-0.2-0.1-0.4-0.4-0.5c-0.1,0-0.3,0-0.7,0h-2.9l4.7-5h2.8l-3,3c0.8,0,1.3,0.1,1.6,0.2c0.3,0.2,0.5,0.5,0.5,1       c0,0.3,0,0.6-0.1,1L20.1,22.3L20.1,22.3z M13.5,22.3l2.3-10.7h-2.3l-2.3,10.7H13.5L13.5,22.3z M21.3,24.5H14l0,0l-0.1,0.7       l-0.2,1.2h12.8c1.1,0,1.8-0.1,2.2-0.4c0.4-0.3,0.7-0.9,0.9-1.8l2.1-9.8h-2.3l-1.3,6.1h-2.7c-0.4,0-0.6,0-0.7,0       c-0.3-0.1-0.4-0.2-0.4-0.5c0-0.1,0-0.3,0.1-0.6l1.1-5h-2.3l-1.2,5.7c-0.1,0.4-0.1,0.8-0.1,1c0,0.5,0.2,0.8,0.5,1       c0.3,0.2,0.9,0.2,1.8,0.2h3.6l-0.2,1c-0.1,0.5-0.3,0.8-0.4,0.9c-0.2,0.1-0.5,0.2-1,0.2H21.3L21.3,24.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.9,0c9.4,0,17,7.6,17,17c0,9.4-7.6,17-17,17c-9.4,0-17-7.6-17-17C32.9,7.6,40.5,0,49.9,0z M53.9,22.3       l1.7-8h-2.3l-1.1,5c-0.1,0.5-0.3,0.8-0.4,0.9c-0.2,0.1-0.5,0.2-1,0.2H49c-0.4,0-0.6,0-0.7,0c-0.3-0.1-0.4-0.2-0.4-0.5       c0-0.1,0-0.3,0.1-0.6l1.1-5h-2.3l-1.2,5.7c-0.1,0.4-0.1,0.8-0.1,1c0,0.5,0.2,0.8,0.5,1c0.3,0.2,0.9,0.2,1.8,0.2h2.4       c0.7,0,1.3-0.3,1.7-1l-0.2,1L53.9,22.3L53.9,22.3z M45.6,11.7h-2.3L42.3,16h-4.1l0.9-4.4h-2.3l-2.3,10.7h2.3l0.9-4.4h4.1       L41,22.3h2.3L45.6,11.7L45.6,11.7z M64.4,20.1l0.8-3.5c0.1-0.4,0.1-0.8,0.1-1c0-0.5-0.2-0.8-0.5-1c-0.3-0.2-0.9-0.3-1.8-0.3       h-2.8l-0.4,1.9h1.9c0.4,0,0.6,0,0.7,0c0.3,0.1,0.4,0.2,0.4,0.5c0,0.1,0,0.3-0.1,0.6l-0.4,1.9c-0.1,0.5-0.3,0.8-0.5,1       c-0.1,0.1-0.5,0.1-1,0.1h-2.8l1.9-8.8h-2.3l-2.3,10.7h5.9c1.1,0,1.8-0.1,2.2-0.4S64.2,21,64.4,20.1L64.4,20.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M73.6,22.3h-2.4l1.8-8.6h-2.6l0.4-2.1h7.6L78,13.8h-2.6L73.6,22.3L73.6,22.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M86.6,22.3l1.4-6.5l-4,6.5h-1.9l-1.3-6.5l-1.4,6.5h-2l2.3-10.7h2.6l1.4,7.4l4.6-7.4h2.5l-2.3,10.7H86.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M90.2,22.3l0.4-2.1h5.7c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.2-0.4l0.3-1.5c0,0,0-0.1,0-0.2       c0-0.2-0.1-0.3-0.4-0.3h-4.2c-0.4,0-0.7-0.1-0.9-0.3c-0.2-0.2-0.3-0.4-0.3-0.8c0-0.1,0-0.3,0-0.5l0.6-2.8       c0.1-0.6,0.4-1.1,0.7-1.4c0.3-0.3,0.8-0.5,1.5-0.5h6.6l-0.4,2h-5.7c-0.2,0-0.3,0-0.4,0.1c-0.1,0.1-0.1,0.2-0.2,0.4L94,15.6       c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.2,0.1,0.2,0.3,0.2h4.3c0.4,0,0.8,0.1,1,0.3c0.2,0.2,0.3,0.5,0.3,0.8c0,0.1,0,0.3,0,0.4       l-0.6,2.9c-0.1,0.6-0.4,1.1-0.7,1.4c-0.3,0.3-0.8,0.5-1.5,0.5H90.2L90.2,22.3z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiderLogo);
export default __webpack_public_path__ + "static/media/icon_sider_logo.b3421cced7370f5abf38f1e00a0d4db9.svg";
export { ForwardRef as ReactComponent };